module.exports = {
  footerText: 'Thea - Centralna baza zgód marketingowych © 2021',
}
